import { render, staticRenderFns } from "./ListiniTariffe.vue?vue&type=template&id=0d56d57d&"
import script from "./ListiniTariffe.vue?vue&type=script&lang=ts&"
export * from "./ListiniTariffe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports